/* SUVENE Sets: "Complete the set" (Produktseite) und Set-Seite (Tracksuits).
   Legt Ober- und Unterteil mit einem Klick in den Warenkorb. Der Rabatt kommt ausschliesslich aus dem
   automatischen Shopify-Rabatt "Kaufe X, erhalte Y" – hier wird kein Preis berechnet oder gesendet. */
(function () {
  if (window.SuSets) return;

  function addItems(items) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { return r.json(); });
  }

  function openCart(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents({ sections: data.sections });
    } else {
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  }

  function checkedValue(scope) {
    var input = scope && scope.querySelector('.su-set-sizes__input:checked');
    return input ? input.value : '';
  }

  /* Variante der Hauptproduktform auf der Produktseite (leer, solange keine Groesse gewaehlt ist) */
  function mainVariant() {
    var input = document.querySelector('[id$="__main"] form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? input.value : '';
  }
  /* Größen-Radios oben (erste Option der Hauptform) */
  function mainRadios() {
    return Array.prototype.slice.call(document.querySelectorAll('[id$="__main"] input[type="radio"][data-position="1"]'));
  }
  function labelOf(input) {
    var l = input && input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    return (l ? l.textContent : (input ? input.value : '')).trim();
  }
  /* Fehlende Größe benennen und die Reihe kurz hervorheben */
  function flag(fieldset) {
    if (!fieldset) return;
    fieldset.classList.remove('is-missing'); void fieldset.offsetWidth; fieldset.classList.add('is-missing');
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { fieldset.classList.remove('is-missing'); }, 1800);
  }
  function legendText(fieldset) {
    var l = fieldset && fieldset.querySelector('.su-set-sizes__legend');
    return l ? l.textContent.trim() : 'Size';
  }

  function init(root) {
    if (root.dataset.suSetReady) return;
    root.dataset.suSetReady = '1';
    var mode = root.dataset.suSet; // "pdp" oder "detail"
    var button = root.querySelector('[data-su-set-add]');
    var label = root.querySelector('[data-su-set-add-label]');
    var message = root.querySelector('[data-su-set-message]');
    var defaultLabel = label ? label.textContent : '';

    function say(text) {
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
    }

    /* Farbwahl des Unterteils (nur Produktseite) */
    root.querySelectorAll('[data-su-set-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var id = option.dataset.suSetOption;
        root.querySelectorAll('[data-su-set-option]').forEach(function (o) {
          o.classList.toggle('is-active', o === option);
          o.setAttribute('aria-pressed', o === option ? 'true' : 'false');
        });
        root.querySelectorAll('[data-su-set-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.suSetPanel !== id;
        });
        root.querySelectorAll('[data-su-set-media]').forEach(function (media) {
          media.hidden = media.dataset.suSetMedia !== id;
        });
        var color = root.querySelector('[data-su-cset-color]');
        if (color && option.dataset.color) color.textContent = option.dataset.color;
        var sum = root.querySelector('[data-su-cset-sum]');
        if (sum && option.dataset.sum) sum.textContent = option.dataset.sum;
        say('');
      });
    });

    /* Eingeklappter Block (Produktseite): sanft auf- und zuklappen, #complete-set öffnet ihn */
    var toggle = root.querySelector('[data-su-cset-toggle]');
    if (toggle) {
      var setOpen = function (open) {
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      toggle.addEventListener('click', function () { setOpen(!root.classList.contains('is-open')); });
      var fromHash = function () {
        if (location.hash === '#complete-set') {
          setOpen(true);
          setTimeout(function () { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
        }
      };
      fromHash();
      window.addEventListener('hashchange', fromHash);
    }

    root.addEventListener('change', function (e) {
      if (e.target.classList.contains('su-set-sizes__input')) say('');
    });

    /* Produktseite: Größe im Block und oben synchron halten */
    var own = root.querySelector('[data-su-set-own]');
    if (own) {
      var syncing = false;
      var fromMain = function () {
        var checked = mainRadios().filter(function (r) { return r.checked; })[0];
        if (!checked) return;
        var want = labelOf(checked);
        own.querySelectorAll('.su-set-sizes__input').forEach(function (inp) {
          var lab = own.querySelector('label[for="' + inp.id + '"]');
          if (lab && lab.textContent.trim() === want && !inp.disabled) inp.checked = true;
        });
      };
      own.addEventListener('change', function (e) {
        if (syncing || !e.target.classList.contains('su-set-sizes__input')) return;
        var lab = own.querySelector('label[for="' + e.target.id + '"]');
        var want = lab ? lab.textContent.trim() : '';
        var match = mainRadios().filter(function (r) { return labelOf(r) === want; })[0];
        if (match && !match.checked) {
          syncing = true;
          var ml = document.querySelector('label[for="' + match.id + '"]');
          if (ml) ml.click(); else { match.checked = true; match.dispatchEvent(new Event('change', { bubbles: true })); }
          setTimeout(function () { syncing = false; }, 50);
        }
      });
      document.addEventListener('change', function (e) {
        if (syncing || !e.target.matches || !e.target.matches('[id$="__main"] input[type="radio"][data-position="1"]')) return;
        fromMain();
      });
      fromMain();
    }

    if (!button) return;
    button.addEventListener('click', function () {
      var top, bottom;
      var visiblePanel = root.querySelector('[data-su-set-panel]:not([hidden])');
      var topPart = root.querySelector('[data-su-set-part="top"]');
      if (mode === 'pdp') {
        top = checkedValue(topPart) || mainVariant();
      } else {
        top = checkedValue(topPart);
      }
      bottom = checkedValue(visiblePanel || root.querySelector('[data-su-set-part="bottom"]'));
      if (!top) { say(root.dataset.msgTop); flag(topPart && topPart.querySelector('.su-set-sizes')); return; }
      if (!bottom) {
        var fs = (visiblePanel || root).querySelector('.su-set-sizes');
        say((fs && fs.getAttribute('data-msg')) || root.dataset.msgBottom);
        flag(fs);
        return;
      }

      button.disabled = true;
      if (label) label.textContent = '…';
      addItems([{ id: Number(top), quantity: 1 }, { id: Number(bottom), quantity: 1 }])
        .then(function (data) {
          if (data.status) {
            say(data.description || data.message || root.dataset.msgError);
            if (label) label.textContent = defaultLabel;
            button.disabled = false;
            return;
          }
          say('');
          if (label) label.textContent = '✓';
          if (mode === 'panel') closePanel();
          openCart(data);
          setTimeout(function () { if (label) label.textContent = defaultLabel; button.disabled = false; }, 1500);
        })
        .catch(function () {
          say(root.dataset.msgError);
          if (label) label.textContent = defaultLabel;
          button.disabled = false;
        });
    });
  }

  /* Seitenpanel auf Kollektionsseiten: Klick auf "Set …" unter einer Kachel lädt /products/<handle>?view=su-set */
  var panelEl = null, lastFocus = null;
  function ensurePanel() {
    if (panelEl) return panelEl;
    panelEl = document.createElement('div');
    panelEl.className = 'su-setpanel';
    panelEl.setAttribute('role', 'dialog');
    panelEl.setAttribute('aria-modal', 'true');
    panelEl.setAttribute('aria-label', document.documentElement.getAttribute('data-su-set-panel') || 'Complete the set');
    panelEl.innerHTML = '<div class="su-setpanel__backdrop" data-su-setpanel-close></div>' +
      '<aside class="su-setpanel__box"><button type="button" class="su-setpanel__close" data-su-setpanel-close aria-label="' + (document.documentElement.getAttribute('data-su-close') || 'Close') + '">' +
      '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.3"/></svg></button>' +
      '<div class="su-setpanel__content"></div></aside>';
    document.body.appendChild(panelEl);
    panelEl.addEventListener('click', function (e) { if (e.target.closest('[data-su-setpanel-close]')) closePanel(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panelEl.classList.contains('is-open')) closePanel(); });
    return panelEl;
  }
  function closePanel() {
    if (!panelEl) return;
    panelEl.classList.remove('is-open');
    document.documentElement.classList.remove('su-setpanel-lock');
    if (lastFocus) lastFocus.focus();
  }
  function openPanel(url, pre) {
    var el = ensurePanel();
    var content = el.querySelector('.su-setpanel__content');
    content.innerHTML = '<p class="su-setpanel__loading">…</p>';
    el.classList.add('is-open');
    document.documentElement.classList.add('su-setpanel-lock');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=su-set')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        content.innerHTML = html;
        var root = content.querySelector('[data-su-set]');
        if (!root) { content.innerHTML = ''; closePanel(); window.location.href = url + '#complete-set'; return; }
        init(root);
        if (pre) {
          var opt = root.querySelector('[data-su-set-option="' + pre + '"]');
          if (opt) opt.click();
        }
        var close = el.querySelector('.su-setpanel__close');
        if (close) close.focus();
      })
      .catch(function () { closePanel(); window.location.href = url + '#complete-set'; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-su-set-open]') : null;
    if (!a) return;
    e.preventDefault();
    lastFocus = a;
    openPanel(a.getAttribute('data-su-set-open'), a.getAttribute('data-su-set-pre'));
  });

  window.SuSets = { init: init, addItems: addItems, openPanel: openPanel, closePanel: closePanel };
  function boot() { document.querySelectorAll('[data-su-set]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
